/**
 * แท็บของ dataset — มาจาก displayItems ใน chartinfo.json ที่ pipeline เขียนเท่านั้น
 *
 * เคยมีแท็บ Favorites ของ MeLab แทรกไว้ข้างหน้าด้วย แต่ MeLab ถูกถอดออกทั้งโดเมน
 * เมื่อ 2026-08-10 เหลือแค่แท็บมาตรฐาน — ถ้าจะเพิ่มแท็บพิเศษอีกครั้ง ให้ pipeline
 * เป็นคนประกาศผ่าน chartinfo ห้าม UI เทียบชื่อ dataset เอง
 */
export const getDatasetTabs = (
  datasetId: string | null | undefined,
  chartInfo: any,
): string[] => Object.keys(chartInfo?.[datasetId || ""]?.displayItems || {});

export const defaultDatasetTab = (
  datasetId: string | null | undefined,
  chartInfo: any,
) => getDatasetTabs(datasetId, chartInfo)[0] || "";
